import { forwardRef, useEffect, useState } from "react";
import Input from "@/atoms/Input";
import { SearchIcon } from "@/atoms/Icons";
import { CloseIcon } from "@/atoms/Icons";
import { isMobileScreen } from "@/utils/functions";

const SearchBar = forwardRef(
  ({ onSearchValue, label, required, desc, ...props }, ref) => {
    const [isMobile, setIsMobile] = useState(null);

    useEffect(() => {
      setIsMobile(isMobileScreen);
    }, []);

    const debounce = (func, delay) => {
      let timerId;
      return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
          func(...args);
        }, delay);
      };
    };

    const inputChangeHandler = debounce(() => {
      onSearchValue(ref.current.value);
    }, 500);

    const focusHandler = (e) => {
      const commonParent = e.target.closest(".container");
      const dropdownElem = commonParent.getElementById("dropdown-wrapper");
      const isDropdownOpen = dropdownElem.classList.contains("is-open");
      if (!isDropdownOpen) return;
      dropdownElem.classList.remove("is-open");
    };

    return (
      <div
        className={`searchbar awd-input-wrapper ${isMobile ? "m-center" : ""}`}
      >
        <Input
          ref={ref}
          {...props}
          onChange={inputChangeHandler}
          onFocus={isMobile ? focusHandler : undefined}
        />
        <SearchIcon className="icon search-icon mr-1" />
        <label className="awd-input-label" htmlFor="name">
          {label}
          <span className="awd-input-required">{required && " *"}</span>
        </label>
        <CloseIcon
          width="18"
          height="18"
          color="#9F9FAF"
          className="icon close-icon mr-1"
          onClick={() => (ref.current.value = "")}
        />
        {desc && <span className="awd-input-desc">{desc}</span>}
      </div>
    );
  }
);

export default SearchBar;
